import EventEmitter from '../helpers/EventEmmiter';
import ConfirmAlert from './modules/confirm-alert';
import {patchOldPOI} from "../../pannellum-poi-editor/poi-service";

require('./e3-tour-info.scss');

// const Quill = require('../../pannellum-poi-editor/quill-editor/quill.min.js');
const template = require('./e3-tour-info.html');

class E3TourInfo extends EventEmitter {
    _wrapper = null;
    _container = null;
    _contentNode = null;
    _closeButton = null;
    _options = {
        editor: true
    };

    _cache = '';

    _handlers = {};

    constructor(wrapper, options = {}, translationService){
        super();

        this._wrapper = wrapper;
        this._translationService = translationService;

        this._prepareOptions(options);
        this._init();
    }

    _prepareOptions(options) {
        Object.keys(this._options).forEach((key) => {
            if (options.hasOwnProperty(key)) this._options[key] = options[key];
        });
    }

    _init() {
        let {editor} = this._options;
        let container = document.createElement('div');

        container.classList.add('e3-tour-info');
        this._wrapper.appendChild(container);

        if (editor) {
            container.innerHTML = template;

            this._editor = this._initEditor(container);
            this._closeButton = document.querySelector('.info-editor__toolbar-close button');
            this._contentNode = container.querySelector('.ql-editor');

            var customButton = container.querySelector('.ql-street');
            customButton.addEventListener('click', () => {
                this._fireEvent('ql-street-open', {editor: this._editor});
            });
        } else {
            let viewer = this._initViewer(container);

            this._closeButton = viewer.querySelector('.info-viewer__toolbar button');
            this._contentNode = viewer.querySelector('.info-viewer__body');
        }

        this._container = container;

        this._bindEvents()
    }

    _initEditor(container) {
        let editorContainer = container.querySelector('.info-editor');

        this._confirmAlert = new ConfirmAlert(editorContainer, this._translationService);

        return new Quill('.info-editor__wrapper__body', {
            theme: 'bubble',
            modules: {
                toolbar: {
                    container: '.info-editor__toolbar',
                    handlers: {
                        'save': () => this._onSave(),
                        'delete': () => this._onDelete(),
                    }
                },
                history: {
                    delay: 1000,
                    maxStack: 100,
                    userOnly: true,
                    buttons: {
                        'undo': '.ql-undo',
                        'redo': '.ql-redo',
                    }
                }
            },
            tooltipContainer: container.querySelector('.info-editor__toolbar')
        });
    }

    _initViewer(container) {
        let wrapper = document.createElement('div');
        let toolbar = document.createElement('div');
        let body = document.createElement('div');
        let close = document.createElement('button');

        wrapper.classList.add('info-viewer');
        toolbar.classList.add('info-viewer__toolbar');
        body.classList.add('info-viewer__body');

        toolbar.appendChild(close);
        wrapper.appendChild(toolbar);
        wrapper.appendChild(body);
        container.appendChild(wrapper);

        return wrapper;
    }

    _onSave() {
        let html = this._contentNode.innerHTML;

        return new Promise((resolve, reject) => this._fireEvent('tour-info.save', {html, resolve, reject}))
            .then(() => this._updateCache())
    }

    _onDelete() {
        return this._confirmAlert.show('CONFIRM_ALERT_SURE')
            .then(() => {
                return new Promise((resolve, reject) => this._fireEvent('tour-info.delete', {resolve, reject}))
            })
            .then(() => this.hide())
            .catch(() => {/* ... */})
    }

    _bindEvents() {
        let close = this._closeButton;
        let closeHandler = this._options.editor ? this.cancel.bind(this) : this.hide.bind(this);

        this._handlers.close = {
            element: close,
            handler: closeHandler
        };

        close.addEventListener('click', closeHandler);
    }

    _unbindEvents() {
        Object.keys(this._handlers).forEach((key) => {
            let element = this._handlers[key].element;
            let handler = this._handlers[key].handler;

            element.removeEventListener('click', handler);

            delete this._handlers[key];
        });
    }

    _show() {
        this._container.classList.add('show');
    }

    _hide() {
        this._container.classList.remove('show');
    }

    _insertBody(body) {
        this._cache = body;
        this._contentNode.innerHTML = body;
    }

    _updateCache() {
        this._cache = this._contentNode.innerHTML;
    }

    getContent() {
        return this._contentNode.innerHTML;
    }

    isDirty() {
        return this._contentNode.innerHTML !== this._cache
    }

    show(body) {
        body = patchOldPOI(body);
        this._insertBody(body);
        this._show();

        if (this._editor) this._editor.focus();
    }

    hide() {
        this._hide();
        this._fireEvent('tour-info.cancel');
    }

    cancel() {
        let html = this._contentNode.innerHTML;
        let promise = Promise.resolve();

        if (html !== this._cache) {
            promise = this._onSave()
        }

        promise
            .then(() => this.hide())
            .catch(() => { /* ... */ })
    }

    isShown() {
        return this._container.classList.contains('show');
    }

    destroy() {
        if (this._options.editor) this._confirmAlert.destroy();

        this._unbindEvents();

        this._wrapper.removeChild(this._container);
    }
}

export default E3TourInfo;
